export const SERVER_URL = import.meta.env.PROD 
  ? 'https://febro-portfolio-backend.fly.dev'
  : 'http://localhost:5000';

export const API_ENDPOINTS = {
  CONTACT: `${SERVER_URL}/api/contact/saveMsg`,
} as const;  